<template>
  <div class="product_info">
    <div class="product_info_pot">
      <div class="mainTitle">{{proTitle}}</div>
      <!-- mainpic -->
      <div class="pro_img_cup">
        <img :src="mianPic" alt="">
      </div>
      <div v-html='productText' class="pro_text_cup"></div>
      <!-- params -->
      <div class="para_cup">
        <img :src="picPara" max-width='80%' alt="">
      </div>
    </div>
  </div>
</template>
<script>
import { oneProductInfo } from '@/api/enFrontApi/product';
export default {
  data() {
    return {
      mianPic: '../../../../static/img/product/vehicle-1.png',
      picPara: '',
      proTitle: '',
      productText: ''
    };
  },
  created() {
    this.initProduct(this.$route.params.productId);
  },
  methods: {
    initProduct(pid) {
      oneProductInfo(parseInt(pid)).then(res => {
        this.mianPic = res.data.picMain;
        this.picPara = res.data.picPara;
        this.proTitle = res.data.proTitle;
        this.productText = res.data.proBody;
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.product_info {
  width: 100%;
  min-height: 600px;

  .product_info_pot {
    width: 60%;
    margin: 0 auto;

    .pro_img_cup {
      width: 100%;
      min-height: 300px;
      text-align: center;

      img {
        display: block;
        max-width: 80%;
        margin: 0 auto;
      }
    }

    .all_pro_imgs {
      width: 100%;
    }

    .pro_text_cup {
      padding: 15px 0 5px;
      width: 100%;
    }
  }
}

.para_cup {
  margin: 10px 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/enViews/product/productInfo.vue